<template>
    <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "ext_of_od_cover"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#extensionOd"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Extension of OD Cover</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="extensionOd">
        <div class="row" v-if="extensionODCoverData.policyExpiryDate.visibility">
            <!--Policy Expiry Date* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
              <float-label label="Policy Expiry Date*" :fixed="isFloat(extensionODCoverData.policyExpiryDate.value)">
                <datepicker
                  v-model="extensionODCoverData.policyExpiryDate.value"
                  v-evolvews="extensionODCoverData.policyExpiryDate"
                  :typeable="true"
                  format="dd/MM/yyyy"
                  :input-class="isInputError(extensionODCoverData.policyExpiryDate.errorText)"
                  @selected="checkError(extensionODCoverData.policyExpiryDate,false)"
                  @input="checkError(extensionODCoverData.policyExpiryDate,false)"
                  placeholder="Policy Expiry Date*"
                ></datepicker>
              </float-label>
              <span
                class="error-text"
                v-if="extensionODCoverData.policyExpiryDate.errorText !== ''"
              >{{extensionODCoverData.policyExpiryDate.errorText}}</span>
            </div>
          </div>
          <!--Policy Expiry Date ends-->
          <!--Policy Expiry Time* starts-->
          <div class="col-lg-6">
            <div class="row form-group">
              <float-label 
                label="Time" 
                :fixed='isFloat(extensionODCoverData.policyExpiryTime.value)'>
              <vue-timepicker 
              v-model="state.time"
              v-evolvews="extensionODCoverData.policyExpiryTime"
              :input-class="isInputError(extensionODCoverData.policyExpiryTime.errorText)"
              @selected="checkError(extensionODCoverData.policyExpiryTime,false)" 
              @input="checkError(extensionODCoverData.policyExpiryTime,false)" 
              format="hh:mm A">
              </vue-timepicker>
              </float-label>
              <span
                class="error-text"
                v-if="extensionODCoverData.policyExpiryTime.errorText!==''"
              >{{extensionODCoverData.policyExpiryTime.errorText}}</span>
                <!-- v-model="extensionODCoverData.policyExpiryTime.value" -->
            </div>
          </div>
          <!--Policy Expiry Time* ends-->
        </div>
    </div>
</div>
</template>
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import VueTimepicker from 'vuejs-timepicker';
import functions from "@/../../masters/functions.js";
import base from "@/../../masters/base.js";
import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
import vSelect from "vue-select";
import { reactive, onUpdated } from "@vue/composition-api";
export default {
    name: "ExtensionODCover",
    props: ["extensionODCoverData"],
    components: {
    FloatLabel,
    Datepicker,
    VueTimepicker,
    vSelect
  },
  setup(props, context) {
    let state = reactive({
        time:{
         hh : null, mm : null, A :null
      }
    });
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const isFloat = functions.isFloat;

    onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.extensionODCoverData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
       context.parent.enableCalculatePremiumBtn('extensionOfODCover');
    })
    return {
      state,
      isFloat,
      checkError,
      isInputError
    };
  },
   directives: {
    evolvews: functions.evolvews
  }
}
</script>

